import React, { Suspense } from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import the used chats for the application

const ChatUserlike = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/chat-userlike'));
const ChatPlazz = React.lazy(() => import('src/shared_modules/veu-visitors-plazz/components/chat'));

/*
 * ---------------------------------------------------------------------
 * class
 * ---------------------------------------------------------------------
 */
class ChatProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
        }
    }

    componentDidMount() {
        this.setState({ isLoading: false });
    }

    render() {
        let { pathname } = this.props.location;
        let enablePlazzChat = false;

        // if user is on home he has no access to event for any reason so there is no chat!!!!
        if (!pathname.endsWith("home") && !pathname.endsWith("preregister")) {
            // mount plazz chat only if it is enabled and the user is logged in
            // The ChatPlazz komponent renders (null) if closed but polls the chats and users in background
            enablePlazzChat = this.props.hasPlazzConvention && this.props.hasPlazzChat && this.props.user.loggedIn && this.props.user.plazz;
        }
        // userlike is always included the component cannot be mounted/unmounted on the fly
        // this would cause cors error in the widgets javascript
        return (<div>
                <Suspense>
                    { enablePlazzChat && <ChatPlazz /> }
                    { this.props.hasUserlike && <ChatUserlike /> }
                </Suspense>
            </div>);
    }
}

ChatProvider.propTypes = {
    hasPlazzConvention: PropTypes.bool,
    hasPlazzChat: PropTypes.bool,
    hasUserlike: PropTypes.bool,
    user: PropTypes.object,
    event: PropTypes.object,
}
/*
 * ---------------------------------------------------------------------
 * Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = (state, ownProps) => {
    return {
        hasPlazzConvention: state.event.hasPlazzConvention,
        hasPlazzChat: state.event.hasPlazzChat,
        hasUserlike: state.event.hasUserlike,
        user: state.user,
        event: state.event,
    };
};
/*
* ---------------------------------------------------------------------
* Export the redux container
* ---------------------------------------------------------------------
*/
export default connect(
    mapStateToProps,
)(withRouter(ChatProvider));
